module.exports = __webpack_public_path__ + "img/resized-cover5.fa0fcb7d.png";